import React, { useRef, useState, useEffect } from "react";
import { FieldProps } from "formik";
import { convertFiletoBase } from "utils/helpers";
import UserAvatar from "react-user-avatar";
import {connect} from "react-redux";

import { IRootState } from "reducers";

import Delete from "img/delete-black.svg";

interface IProps {
  isEdit: boolean;
  username: string;
}

const LoadAvatar: React.SFC<IProps & FieldProps> = ({
  field: { name, value, ...fieldProps },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  isEdit,
  username,
  ...props
}) => {
  const inputEl = useRef<any | undefined>(undefined);

  const [image, setImage] = useState<any>(
    typeof value === "string" ? value : undefined
  );

  const showDownloadedImage = () => {
    // if (value !== null && typeof value !== "string") {
    if (value instanceof File) {
      convertFiletoBase(value).then((result: any) => {
        setImage(result);
      });
    } else if (!value) {
      setImage(undefined);
    } else {
      setImage(value);
    }
  };

  useEffect(
    () => {
      showDownloadedImage();
    },
    [value]
  );

  const onButtonClick = () => {
    inputEl.current.click();
  };

  const onChangeFile = (e: any) => {
    if (e.target.value) {
      setFieldValue(name, e.target.files[0]);
    } else {
      e.preventDefault();
    }
  };

  const clearProfImg = (e:any) => {
    setFieldValue(name, undefined);
  }

  return (
    <div className="col-12 col-md-6">
      <div className="prof__photo m-auto text-center">
      {isEdit && value && (<div className="delete-prof-img" onClick={clearProfImg} ><img src={Delete} /></div>)}
        <div className="prof-block-for-img">
          <UserAvatar size="166px" name={username} src={image} alt="" />
        </div>
        {isEdit && (
          <button className="prof__photo-add text-left" onClick={onButtonClick}>
            {!value ? 'Добавить фото' : 'Изменить фото'}<span>+</span>
          </button>
        )}
        <input
          ref={inputEl}
          className="news__fileinput"
          onChange={onChangeFile}
          type="file"
          name="t1"
          id="filedropper"
          style={{ display: "none" }}
          accept=".jpg,.png,.jpeg"
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ user }: IRootState) => ({
  username: `${user.second_name} ${user.first_name}`,
});

export default connect(mapStateToProps)(LoadAvatar);
